module.exports = {
      id: "logout-usage",
      viewBox: "0 0 75 28",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#logout",
      toString: function () {
        return this.url;
      }
    }